import { combineReducers } from '@ngrx/store';

import { queryInput } from './query-input/query-input.reducer';
import { searchCategoryPageNum } from './search-category-page-num/search-category-page-num.reducer';
import { searchTypes } from './search-types/search-types.reducer';

export const searchAllParams = combineReducers({
    searchTypes,
    queryInput,
    searchCategoryPageNum,
});
